import React, { Component } from "react";
import { features, TablePipeline, BaseTable } from "ali-react-table";

import BsyCheckBox from "../../BsyCheckBox";

import "./index.css";
import { BsyUtils } from "../../../utils/Utils";
import { BsyConfig } from "../../../global/BsyConfig";
import BsySLoading from "../../BsySLoading";
import BsyTurnPage from "../../BsyTurnPage";
import { getAfterSuffix } from "../../../utils/getAfterSuffix";

export default class BsyPivotTable extends Component {
  static defaultProps = {
    url: "/data/report_combined_group",
    asyncExportURL: "/data/combined_group/excel_export",
    columns: [],
    dataSource: [],
    yFields: [],
    xFields: [],
    forms: [],
    dashTitle: "",
    title: "",
    valueFields: [],
    isHeadSticky: true,
    isRowHeadSticky: true,
    summaryTitleAlignment: null,
    autoLoad: true,
    mountAutoLoad: true,
    placeholderStr: "ggdfefjfed",
    headercodeSplitstr: "___￡___", //处理一个冷门符号 用区内容分割
  };

  constructor(props) {
    super(props);
    this.state = {
      columns: props.columns,
      url: props.url,
      sort: props.defaultSort,
      widgetId: props.widgetId,
      appId: props.appId,
      entryId: props.entryId,
      isHeadSticky: props.isHeadSticky,
      headercodeSplitstr: props.headercodeSplitstr,
      isRowHeadSticky: props.isRowHeadSticky,
      summaryTitleAlignment: props.summaryTitleAlignment,
      yFields: props.yFields,
      xFields: props.xFields,
      valueFields: props.metrics,
      forms: props.forms,
      dashTitle: props.dashTitle,
      title: props.title,
      isLoading: false,
      pipelineState: {},
      dataEmpty: false,
      autoLoad: props.autoLoad,
      limit: 50,
      skip: 0,
      chartType: "pivot_table",
    };
    this.popupFormPath = [...props.popupFormPath];
    this.linkParam = null;
    this.element = React.createRef();
    this.scrollLeft = 0;
    this.isDashFull = props.isDashFull;
    this.g_header = [];
    this.g_data = [];

    this.widgetName = "ddd_" + new Date().getTime();
    this.platform = BsyUtils.detectOS();
  }

  _getLinkFilterParams = (e) => {
    let i = this.props,
      a = [];
    BsyUtils.forEach(e, function (e, n) {
      // t.extend(BsyUtils.pick(n, ["method", "type", "value", "keyType"]), BsyUtils.dealFilterInfoByField({
      //   id: i.forms[0],
      //   name: n.field
      // })
      a.push({
        ...BsyUtils.pick(n, ["method", "type", "value", "keyType"]),
        ...BsyUtils.dealFilterInfoByField({
          id: i.forms[0],
          name: n.field,
        }),
      });
    });
    return a;
  };

  doClearLink = () => {
    let t = this.props;
    BsyUtils.applyFunc(this, t.onClearLink, [this.linkParam], null);
    this.linkParam = null;
  };

  onItemClick = (datas) => {
    let t = this.props;
    if (!BsyUtils.isObjectEmpty(datas)) {
      let n = this._getLinkParams(datas);
      n = this._getLinkFilterParams(n);
      this.linkParam = n;
      this.linkParam = this.linkParam.concat(this.getFilterData().cond);
      const linkParam = this.linkParam.filter((it) => {
        return it;
      });
      BsyUtils.applyFunc(this, t.onItemClick, [linkParam], !1);
    } else {
      this.linkParam = [];
      BsyUtils.applyFunc(this, t.onItemClick, [this.linkParam], !1);
    }
  };

  setPipelineState = (updater) => {
    // this.setPipelineState 被调用时，第一个参数 updater 是一个函数
    // updater 接受原来的 pipelineState，返回新的 pipelineState
    this.setState((prev) => ({
      pipelineState: updater(prev.pipelineState),
    }));
  };

  getFilterData = (t) => {
    let e = this.props,
      i1 = BsyUtils.applyFunc(this, e.onDataFilter, [], !1),
      a = [];
    let i = i1.filter;
    this.filterMap = i1.filterMap;
    i && (a = a.concat(i));
    BsyUtils.isObjectEmpty(t) || (a = a.concat(t));
    e.filter && "visit" !== e.mode && (a = a.concat(e.filter.cond));
    return BsyUtils.isObjectEmpty(a)
      ? {}
      : {
          cond: a,
          rel: i1.rel || BsyConfig().CONST.FILTER_RELATION.AND,
        };
  };

  getLastHeaderChildren = (children, i) => {
    if (children && children[0]) {
      if (children[0].children) {
        i = i + 1;
        return this.getLastHeaderChildren(children[0].children, i);
      } else {
        return { index: i, children: children };
      }
    }
    return { index: i, children: children };
  };

  //计算 每列数据的最大宽度
  adjustmentColWidth = (header, data) => {
    let { headercodeSplitstr } = this.props;
    let t3 = new Date().getTime();
    let maxWidth = 500;
    if (this.element.current) {
      maxWidth = this.element.current.offsetWidth / header.length;
      // console.log('adjustmentColWidth :' + this.element.current.offsetWidth / header.length);
    }

    let colWidth = {};
    for (let i = 0; i < data.length; i++) {
      BsyUtils.forEach(data[i], function (a1, b1) {
        let ww = BsyUtils.getSpanTextWidth(b1, "12px", "bold");
        if (!colWidth[a1]) {
          colWidth[a1] = 0;
        }
        if (ww > maxWidth) {
          ww = maxWidth;
        }
        if (colWidth[a1] < ww) {
          colWidth[a1] = ww;
          // console.log('最大值', a1, ww, b1);
        }
      });
    }
    for (let i = 0; i < this.theaderdata.length; i++) {
      BsyUtils.forEach(this.theaderdata[i], function (a1, b1) {
        let dc = b1.split(headercodeSplitstr);
        let ww = BsyUtils.getSpanTextWidth(dc[0], "12px", "bold");
        if (!colWidth[a1]) {
          colWidth[a1] = 0;
        }

        if (colWidth[a1] < ww) {
          colWidth[a1] = ww;
          // console.log('最大值', a1, ww, b1);
        }
      });
    }

    let t4 = new Date().getTime();
    // console.log('colWidth', colWidth, (t4 - t3));

    let lockColWidth = 0;

    let readHeader = (dd) => {
      for (let i = 0; i < dd.length; i++) {
        if (dd[i].children) {
          readHeader(dd[i].children);
        } else {
          if (dd[i].lock) {
            if (colWidth[dd[i].code]) {
              let ww = BsyUtils.getSpanTextWidth(dd[i].name, "12px");
              if (ww > colWidth[dd[i].code]) {
                dd[i].width = ww + 35;
              } else {
                dd[i].width = colWidth[dd[i].code] + 35;
              }
            }
            lockColWidth += dd[i].width;
          } else {
            if (colWidth[dd[i].code]) {
              let ww = BsyUtils.getSpanTextWidth(dd[i].name, "12px");
              if (ww > colWidth[dd[i].code]) {
                dd[i].width = ww + 35;
              } else {
                dd[i].width = colWidth[dd[i].code] + 35;
              }
            }
          }
        }
      }
    };

    let resetHeaderLock = (dd) => {
      for (let i = 0; i < dd.length; i++) {
        if (dd[i].children) {
          resetHeaderLock(dd[i].children);
        } else {
          if (dd[i].lock) {
            dd[i].lock = false;
          }
        }
      }
    };

    readHeader(header);

    //如果冻结的宽超过了，整个表的面板 就按普通的方式展示
    if (
      this.element.current &&
      lockColWidth + 20 > this.element.current.offsetWidth
    ) {
      resetHeaderLock(header);
    }
  };

  //前端分页，由到某些特殊数据，必须前端分页
  goPage = (index, cb) => {
    // console.log('this.widgetName go ', this.widgetName)
    let { limit } = this.state;
    let data = [];
    for (let i = 0; i < limit; i++) {
      if (this.g_data[index * limit + i]) {
        data.push({ ...this.g_data[index * limit + i] });
      }
    }
    if (this.g_data.length === index * limit + data.length) {
      this.gathercolSpanRowIndex = data.length - 1;
      // console.log("218 this.gathercolSpanRowIndex", this.gathercolSpanRowIndex)
    }
    // this.adjustmentColWidth(this.g_header, data);

    this.setState(
      {
        columns: this.g_header,
        dataSource: data,
        skip: index,
        isLoading: true,
        dataEmpty: false,
        gathercolSpanRowIndex: this.gathercolSpanRowIndex,
      },
      () => {
        cb && cb();
      }
    );
  };

  //
  addRowFieldStyle = (yFields) => {
    if (yFields.length == 0) {
      return;
    }

    if (!document.getElementById(this.props.widgetId + "-style")) {
      let styles = "<style id='" + this.props.widgetId + "-style' >\n";
      let that = this;
      BsyUtils.forEach(yFields, (a1, b1) => {
        styles += `
        .pivot_table.${
          that.props.widgetId
        } .art-table .art-table-header thead tr:nth-child(${a1 + 1}) th{
          text-align:${that.getColumnAlign(b1)}
        }
      `;
      });

      styles += "\n</style>";
      BsyUtils.appendStyle(styles);
    }
  };

  loadData = (n, d) => {
    const { url, fields, sort, appId, entryId, widgetId, isLoading } =
      this.state;

    let autoload = this.props.autoLoad;
    if (this.props.onIsAutoLoad) autoload = this.props.onIsAutoLoad();

    if (!autoload) {
      this.setState({
        dataEmpty: true,
      });
      return;
    }

    if (isLoading) {
      return;
    }
    this.isDashFull = n;
    this.setState(
      {
        isLoading: true,
      },
      () => {
        React.axios(
          url,
          {
            fields: fields,
            sort: sort,
            appId: appId,
            entryId: entryId,
            widgetId: widgetId,
            hasCount: false,
            isCountOnly: false,
            filter: this.getFilterData(this.filterParam),
            popupFormPath: this.popupFormPath,
            env: this.props.env || undefined,
          },
          { dashMode: n, autoShowMsg: this.props.env === "dashboard" }
        )
          .then((res) => {
            if (
              this.element.current &&
              this.element.current.querySelector(".art-sticky-scroll")
            )
              this.scrollLeft =
                this.element.current.querySelector(
                  ".art-sticky-scroll"
                ).scrollLeft;

            if (res.data.hasOwnProperty("code") && res.data.code === 3000) {
              //onConfigError
              if (this.props.onConfigError) {
                this.props.onConfigError(res.data);
              }
              if (this.props.onLoadFail) {
                this.props.onLoadFail(n, d);
              }
              return;
            }

            this.resultData = res.data;
            this.addRowFieldStyle(this.resultData.yFields);
            // this.resultData = { "data": { "x": [], "val": [] }, "department": [], "guideline": [], "guideline_val": [], "metrics": [], "user": [], "xFields": [], "yFields": [] }; //{"data":{"x":[{"data":["0503-YL77柜-彰化宗琳","0503-YL77柜-致文","0618-YL92柜-彰化陈韦苍","0618-YL92柜-楊梅洪国章","5863026536","7553588000 7553587996 7553587985 7553587974 7553587963 7553587952 7553587941 7553587930 7553588081 7553588070 7553588066 7553588055 7553588044 7553588033 7553588022 7553588011 7553583214 7553583225 7568008420 7568008416 7568008405 7568008394 7568008383 7568009735 7568009724 7568009713 7568009702 7568009691 7568009680 7568009676 7568009665 7568008372 7568009746 7568009750 7568009761 7568009772 7568009783 7568009794 7568009805 7568009816-彰化宗琳","7567805125-彰化宗琳","7567805140 7567805136-彰化宗琳","7567805243 7567805254 7567805265-彰化宗琳","7567805276-彰化宗琳","7567805280 7567805291-致文","7567805361 7567805372 7567805383 7567805394-致文","7567805405 7567805416 7567805420 7567805431 7567805442-彰化宗琳","7567837900 7567837911 7567837896-彰化宗琳","7567837966 7567837955 7567837944 7567837933 7567837922-彰化宗琳","7567837992   7567837981   7567837970-致文","7567838014   7567838003-致文","7567838025-致文","7567838062 7567838051 7567838040 7567838036 7567838073-致文","7567846510 7567846506 7567846495 7567846484 7567846473-致文","7567847184 7567847173 7567847162 7567847151 7567847140 7567847136 7567847125 7567847114 7567847103 7567847092-彰化宗琳","7567865082 7567865071 7567865060 7567865056   7567865093-致文","7567865244 7567865233 7567865222 7567865211 7567865200 7567865196 7567865185 7567865174 7567865163 7567865152 7567865130 7567865126 7567865115 7567865104 7567865141-彰化宗琳","7567947365 7567947376 7567947380 7567947391 7567947402-致文","7567948076 7567948065 7567948054-致文","7567949200 7567949196 7567949185 7567949174 7567949163-彰化宗琳","7567949211-致文","7567949244 7567949233 7567949222-致文","7568189322 7568189333-致文","7568189344 7568189355 7568189366 7568189370 7568189381 7568189392 7568189403 7568189414 7568189425 7568189436-致文","7568189521 7568189510 7568189506 7568189495 7568189484 7568189473 7568189462 7568189451 7568189440 7568189532-彰化宗琳","7568189580 7568189576 7568189565 7568189554 7568189543-彰化宗琳","7568202530 7568202526 7568202515 7568202504 7568202493 7568202482 7568202471 7568202460-彰化宗琳","7568203683 7568203672 7568203661-致文","7568203742 7568203731 7568203720 7568203716 7568203705-彰化宗琳","7568205212 7568205201-致文","7568247890 7568247901 7568247912-致文","7568247923 7568247934 7568247945 7568247956 7568247960-彰化宗琳","8000387 8000387021-彰化宗琳","HY05.06-74柜-彰化宗琳","hy05.06-74柜-致文","HY05.09-76柜-彰化宗琳","HY05.09-76柜-致文","HY05.27-85柜-彰化宗琳","HY05.27-85柜-致文","HY05.31-87柜-彰化宗琳","HY05.31-87柜-致文","JH0503-12柜-彰化宗琳","JH0503-12柜-致文","JH0504-13柜-彰化宗琳","JH0504-13柜-致文","JH0505-14柜-彰化宗琳","JH0505-14柜-致文","JH0531-23柜-彰化宗琳","JH0531-23柜-致文","JH0606-25柜-彰化陈韦苍","JH0606-25柜-楊梅洪国章","JS0419-91柜-彰化宗琳","JS0419-91柜-致文","JS0426-99柜-彰化宗琳","JS0426-99柜-致文","JS0428-102柜-致文","JS0518-115柜-彰化宗琳","JS0518-115柜-致文","JS0611-129柜-彰化陈韦苍","JS0611-129柜-楊梅洪国章","LD05.08-11柜-彰化宗琳","LD05.08-11柜-致文","SS05.07-07柜-彰化宗琳","SS05.07-07柜-致文","SS05.12-09柜-彰化宗琳","SS05.12-09柜-致文","SS05.15-10柜-彰化宗琳","SS05.15-10柜-致文","SS05.20-12柜-彰化宗琳","SS05.20-12柜-致文","SS05.22-13柜-彰化宗琳","SS05.22-13柜-致文","SS05.28-15柜-彰化宗琳","SS05.28-15柜-致文","SS05.30-16柜-彰化宗琳","SS05.30-16柜-致文","海快0519-YL83柜-彰化宗琳","海快0519-YL83柜-致文"]}],"val":[{"data":[1,3,6,3,6,40,1,2,3,1,2,5,5,3,5,3,2,1,5,5,10,5,15,9,5,5,1,6,2,10,10,5,8,3,5,2,3,5,40,22,33,85,17,15,10,2,2,165,43,42,19,83,44,2,2,4,1,88,49,80,56,6,121,36,11,4,20,13,15,15,33,26,71,38,52,66,38,37,37,31,60,57,3,2],"is_summary_col":false,"sum":1907,"tag":"f_1656316335771","text":"件数","y":[]}]},"department":[],"guideline":[],"guideline_val":[],"metrics":[{"name":"_widget_1616207308889","type":"number","regex":"^[-]?[\\d]{0,}$","title":"件数","form":"5203ba40cedadf72459af309","tag":"f_1656316335771","op":"sum"}],"user":[],"xFields":[{"name":"_widget_1577421654764","type":"text","title":"查货号码","form":"5203ba40cedadf72459af309","tag":"f_1656316335762"}],"yFields":[]};

            if (
              this.resultData.xFields.length === 0 &&
              this.resultData.yFields.length === 0
            ) {
              this.setState(
                {
                  dataEmpty: true,
                  isLoading: false,
                  gathercolSpanRowIndex: this.gathercolSpanRowIndex,
                },
                () => {
                  if (this.props.onLoadSuccess) {
                    this.props.onLoadSuccess(res.data, n, d);
                  }
                }
              );
              return;
            }

            let t1 = new Date().getTime();
            this.g_header = this.transformColumns(this.resultData);

            let red = this.getLastHeaderChildren(
              this.g_header[this.g_header.length - 1].children,
              1
            );
            // console.log(red)
            if (red.children) {
              this.g_header[this.g_header.length - 1].children = red.children;
            }

            // console.log(this.datakeys);

            let t2 = new Date().getTime();
            // console.log("数据转换耗时1：" + (t2 - t1) + 'ms');
            t1 = new Date().getTime();
            this.g_data = this.transformDataSource(this.resultData);
            t2 = new Date().getTime();
            // console.log("数据转换耗时2：" + (t2 - t1) + 'ms');

            if (this.g_data.length === 0) {
              this.setState(
                {
                  dataEmpty: true,
                  isLoading: false,
                  gathercolSpanRowIndex: this.gathercolSpanRowIndex,
                },
                () => {
                  if (this.props.onLoadSuccess) {
                    this.props.onLoadSuccess(res.data, n, d);
                  }
                }
              );
            } else {
              this.reftype = res.data.reftype;
              this.goPage(0, () => {
                if (this.props.onLoadSuccess) {
                  this.props.onLoadSuccess(res.data, n, d);

                  setTimeout(() => {
                    if (
                      this.element.current &&
                      this.element.current.querySelector(".art-sticky-scroll")
                    )
                      this.element.current.querySelector(
                        ".art-sticky-scroll"
                      ).scrollLeft = this.scrollLeft;
                    this.setState({
                      isLoading: false,
                    });
                  }, 10);
                }
              });
              // this.setState({
              //   columns: header,
              //   dataSource: data1,
              //   isLoading: false,
              //   dataEmpty: false,
              // }, () => {
              //   if (this.props.onLoadSuccess) {
              //     this.props.onLoadSuccess(res.data, n, d)
              //   }

              // })
            }
          })
          .catch((res) => {
            if (this.props.onConfigError) {
              if (res.status) {
                this.props.onConfigError(res.data);
              }
            }
            if (this.props.onLoadFail) {
              this.props.onLoadFail(n, d)
            }
            console.error(res);
            this.setState({
              isLoading: false,
              dataEmpty: true,
            });
          });
      }
    );
  };

  doClearLink = () => {
    let t = this.props;
    BsyUtils.applyFunc(this, t.onClearLink, [this.linkParam], null);
    this.linkParam = null;
  };

  reload = (options) => {
    if (options) {
      this.linkParam = options.filter;
    }
    this.setState(
      {
        ...this.state,
        ...options,
      },
      () => {
        this.loadData();
      }
    );
  };

  componentDidMount() {
    if (this.props.getContext) {
      this.props.getContext(this);
    }

    if (!this.props.mountAutoLoad) {
      return;
    }

    this.loadWidget();
  }

  loadWidget = (n, d) => {
    this.loadData(n, d);
  };
  transformgroupRule = (t, e, i) => {
    let _this = this;
    let a = t;

    if (typeof t === "object" && t && t.is_subtotal) {
      return t;
    }

    switch (e.type) {
      case "user":
      case "usergroup": {
        let n = i.user[t];
        a = BsyUtils._toDeptUser(n, "user");
        break;
      }

      case "dept":
      case "deptgroup":
        let s = i.department[t];
        a = BsyUtils._toDeptUser(s, "user");
        break;
      case "datetime":
        if (BsyUtils.isObjectEmpty(t)) {
          a = "";
        } else a = BsyUtils.date2GroupStr(t, e.groupRule || "year");
        break;
      case "location":
      case "address":
        a = "";
        if (BsyUtils.isObjectEmpty(t)) {
          break;
        }
        let o = e.groupRule.split("_");
        BsyUtils.forEach(o, function (e, i) {
          if (i === "city" && a === t[i]) {
            a = "";
          }
          BsyUtils.isEmpty(t[i]) || (a += t[i]);
        });
        break;
      case "flowState":
      case "flowstate":
        let r = BsyConfig().CONST.WORKFLOW.FLOWSTATE;
        let l = {};
        l[r.INPROCESS] = React.language("flow.state.inProcess");
        l[r.COMPLETE] = React.language("flow.node.end");
        l[r.CLOSE] = React.language("flow.state.closed");
        a = l[a] || "";
        break;
      case "flowdecision":
        a = (a && a.text) || "";
        break;
      case "assist_flowid":
        if (!this.flowIdMap) {
          this.flowIdMap = {};
          BsyUtils.forEach(i.flowIdName, function (a1, a2) {
            _this.flowIdMap[a2.value] = a2.text;
          });
        }
        a = this.flowIdMap[a] || "";
        break;
      case "assist_prostatus":
        let l1 = {};
        l1[BsyConfig().CONST.WORKFLOW.FLOWSTATE.INPROCESS] = React.language(
          "mobile.flow.node.doing"
        );
        l1[BsyConfig().CONST.WORKFLOW.FLOWSTATE.COMPLETE] =
          React.language("processed");
        a = l1[a] || "";
        break;
      default: {
      }
    }
    return a;
  };

  initRowHeder = (i, args, type) => {
    let st = [];
    let that = this;
    if (type === "y") {
      if (args.xFields.length === 0) {
        if (i === -1) {
          st = [""];
        } else {
          st = [args.yFields[i].title];
        }
      } else {
        for (let index = 0; index < args.xFields.length; index++) {
          st.push(args.yFields[i].title);
        }
      }
      return st;
    }
    if (i === -1) {
      for (let index = 0; index < args.xFields.length; index++) {
        const element = args.xFields[index];
        if (element.isOrderCol) {
          //isOrderCol
          element.title = React.language("trigger.log.failure.index");
        }
        st.push(element.title + that.state.headercodeSplitstr + element.tag);
      }
    } else {
      for (let index = 0; index < args.xFields.length; index++) {
        st.push(args.data.x[index].data[i]);
      }
    }
    return st;
  };

  //转换数据变成表头格式
  transformChildrenColumns = (headerdata, args) => {
    let that = this;
    let findItem = (i, index, key, children, obj, map) => {
      if (i === 0) {
        findrowitem(children, obj, map);
      } else {
        let newchildren = findkeyitem(key[index], children, map);
        if (newchildren) {
          newchildren.children = newchildren.children || [];
          newchildren.map = newchildren.map || {};
          let sobj = { ...obj, code: [key[index], obj.alias].join(".") };
          index++;
          if (index === key.length) {
            findrowitem(newchildren.children, sobj, newchildren.map);
          } else {
            findItem(
              i,
              index,
              key,
              newchildren.children,
              sobj,
              newchildren.map
            );
          }
        }
      }
      return children;
    };

    let findkeyitem = (key, children, map) => {
      if (map.hasOwnProperty(key)) {
        return children[map[key]];
      }
      return null;
    };

    let findrowitem = (children, obj, childmap) => {
      if (!childmap) {
        childmap = {};
      }
      if (childmap.hasOwnProperty(obj.code)) {
        return false;
      }
      childmap[obj.code] = children.length;
      children.push(obj);
      return true;
    };

    let getKeys = (row, col) => {
      let keys = [];
      let str = "";
      for (let i = 0; i < row; i++) {
        if (str) str = [str, headerdata[i][col]].join(".");
        else str = headerdata[i][col];
        keys.push(str);
      }
      return keys;
    };

    let headers = {
      map: {},
      children: [],
    };

    for (let i = 0; i < headerdata.length; i++) {
      let elem = headerdata[i];
      for (let j = 0; j < elem.length; j++) {
        let colkey = getKeys(i, j);
        let obj = {
          code: elem[j],
          alias: elem[j],
          //标题列 不能联动数据
          name:
            i === headerdata.length - 1 || j < args.xFields.length ? (
              <span className="col-title">
                {(elem[j] + "").indexOf(that.state.headercodeSplitstr) === -1
                  ? elem[j] + ""
                  : (elem[j] + "").split(that.state.headercodeSplitstr)[0]}
              </span>
            ) : (
              <div
                className="cell-linkdata"
                onClick={() => {
                  // console.log(elem, j)

                  let dd = that.getFilterRowHeaderDataId({}, i, j, args);
                  that.onItemClick(dd);
                }}
              >
                {elem[j]}
              </div>
            ),
        };
        if (this.props.placeholderStr === obj.code) {
          obj = {
            code: obj.code,
            name: "",
            alias: obj.code,
          };
        }
        if (obj.code === null || obj.code === undefined || obj.code === "") {
          obj = {
            code: "gather.system", //React.language('gather'),
            name: React.language("gather"),
            children: [],
          };
          for (let index = 0; index < args.metrics.length; index++) {
            obj.children.push({
              code: ["", args.metrics[index].title].join("."),
              alias: args.metrics[index].title,
              name: (
                <span className="col-title">{args.metrics[index].title}</span>
              ),
            });
          }
        }
        findItem(i, 0, colkey, headers.children, obj, headers.map);
        if (i === headerdata.length - 1) {
          this.datakeys.push([colkey[colkey.length - 1], obj.code].join("."));
        }
      }
    }
    return headers.children;
  };

  setCellAlign = (colunms, fields) => {
    colunms.align = this.getColumnAlign(fields);
  };
  getColumnAlign = (header) => {
    if (header.tag === "f_row_order") {
      return "center";
    }

    const { styles } = this.props;

    switch (header.alignment) {
      case "h-left": {
        return "left";
      }
      case "h-right": {
        return "right";
      }
      case "h-center": {
        return "center";
      }
      default: {
        if (styles) {
          if (styles.fontSetting) {
            if (styles.fontSetting.textAlign) {
              return styles.fontSetting.textAlign;
            }
          }
        }
        return "";
      }
    }
  };

  _getLinkParams = (e) => {
    let i = this;
    if (e) {
      let a = [];
      BsyUtils.forEach(e, function (n) {
        let s = i._getFieldByName(n);
        if (s) {
          let o = e[n];

          if (o && o.is_subtotal) {
            return;
          }

          switch (s.type) {
            case "datetime":
              o = BsyUtils.getDateRange(o);
              break;
            case "address":
            case "location":
              o = BsyUtils.getArrayFromRange(o, "address");
              break;
            case "flowdecision": {
              if (o) {
                o = parseInt(o.value, 10);
              }
              break;
            }
            default:
          }
          a.push({ ...BsyUtils.getLinkFilter(s, o), field: s.name });
        }
      });
      return a;
    }
  };
  _getFieldByName = (t) => {
    let e = this.props,
      i = [].concat(e.xFields, e.yFields),
      a = null;
    BsyUtils.forEach(i, function (e, i) {
      if ((i.tag || i.name) === t) {
        a = i;
        return !1;
      }
    });
    return a;
  };

  //点击数据触发联动
  getFilterDataId = (fields, rowIndex, colIndex, args) => {
    const { skip, limit } = this.state;
    const { yFields, xFields } = args;
    // console.log(args);
    // console.log(fields, rowIndex);
    let dd = null;

    //因为翻页需要调整获取数据的位置
    let datastart = skip * limit;
    //取左侧的数据
    if (xFields && xFields.length > 0) {
      xFields.map((data, index) => {
        if (data.tag === "f_row_order") return null;
        if (args.data.x[index].data[rowIndex + datastart]) {
          if (!dd) dd = {};
          dd[data.tag] = args.data.x[index].data[rowIndex + datastart];
        }

        return null;
      });
    }
    if (yFields && yFields.length > 0) {
      yFields.map((data, index) => {
        if (args.data.val[colIndex].y[index]) {
          if (!dd) dd = {};
          dd[data.tag] = args.data.val[colIndex].y[index];
        }

        return null;
      });
    }
    // console.log(dd)
    return dd;
  };
  //
  getFilterColHeaderDataId = (fields, rowIndex, colIndex, args) => {
    const { skip, limit } = this.state;
    const { xFields } = args;
    // console.log(args);
    // console.log(fields, rowIndex);
    let dd = null;

    //因为翻页需要调整获取数据的位置
    let dataindex = skip * limit + rowIndex;
    //取左侧的数据
    if (xFields && xFields.length > 0) {
      let ddindex = 0;
      xFields.map((data, index) => {
        if (data.tag === fields.tag) ddindex = index;
        return null;
      });

      xFields.map((data, index) => {
        if (data.tag === "f_row_order") return null;
        if (index > ddindex) {
          return null;
        }
        if (args.data.x[index].data[dataindex]) {
          if (!dd) dd = {};
          dd[data.tag] = args.data.x[index].data[dataindex];
        }
        return null;
      });
    }
    // console.log(dd)
    return dd;
  };

  getFilterRowHeaderDataId = (fields, rowIndex, colIndex, args) => {
    const { yFields, xFields } = args;
    const { skip, limit } = this.state;
    let dd = null;
    //因为翻页需要调整获取数据的位置
    let datastart = skip * limit; //+ rowIndex
    if (yFields && yFields.length > 0) {
      for (let index = 0; index <= rowIndex; index++) {
        let data = yFields[index + datastart];
        let ddindex = colIndex - xFields.length;
        if (args.data.val[ddindex].y[index + datastart]) {
          if (!dd) dd = {};
          dd[data.tag] = args.data.val[ddindex].y[index + datastart];
        }
      }
    }
    // console.log(dd)
    return dd;
  };

  doResize = () => {
    if (this.props.onReload) {
      this.props.onReload(this.state.skip, this.resultData);
    }
  };
  //处理表头转换
  transformColumns = (args) => {
    let that = this;
    that.colmap = [];
    let headerdata = [];
    that.datakeys = []; //记录列的code 用于data转换使用
    that.gathercolSpanRowIndex = 1; //记录汇总合并的位置
    let len = args.yFields.length;
    for (let index = 0; index < len; index++) {
      let sd = this.initRowHeder(index, args, "y");
      for (let vali = 0; vali < args.data.val.length; vali++) {
        let text = this.transformgroupRule(
          args.data.val[vali].y[index],
          args.yFields[index],
          args
        );
        if (args.data.val[vali].y.length === 0) {
          text = React.language("gather");
        }
        sd.push(text);
      }
      headerdata.push(sd);
    }

    let sd = this.initRowHeder(-1, args);
    if (args.xFields.length === 0) {
      if (sd.length === 0) {
        //占位，一些情况下需要使用
        sd.push(this.props.placeholderStr);
      }
    }

    for (let vali = 0; vali < args.data.val.length; vali++) {
      sd.push(
        args.data.val[vali].text +
          that.state.headercodeSplitstr +
          args.data.val[vali].tag
      );
    }
    headerdata.push(sd);

    // console.log(headerdata);

    let headers = this.transformChildrenColumns(headerdata, args);
    let drilling = (dd) => {
      let ret = null;
      if (dd.children) {
        if (dd.children[0].children) {
          for (let index = 0; index < dd.children.length; index++) {
            let ddd = drilling(dd.children[index]);
            if (ddd) {
              if (!ret) {
                ret = [];
              }
              ret = ret.concat(ddd);
            }
          }
        } else {
          return dd.children;
        }
      } else {
        return [dd];
      }
      return ret;
    };
    let rowHeaders = [];
    let dataStart = 1;
    if (args.yFields.length === 0) {
      //处理列表头的 合并方式 以及对齐
      for (let index = 0; index < args.xFields.length; index++) {
        rowHeaders.push(headers[index]);
      }
      dataStart = args.xFields.length;
    } else {
      rowHeaders = drilling(headers[0]);
      dataStart = 1;
    }

    //提前判断，是否需要取消全部冻结
    let isHeadSticky = this.state.isHeadSticky;
    let elementWidth = this.element?.current?.offsetWidth || 0;
    let dfw = 0;
    for (let index = 0; index < args.xFields.length; index++) {
      const element = args.xFields[index];
      dfw += this.getWidgetWidth(element.type, element.teg);
      if (dfw > elementWidth) {
        isHeadSticky = false;
        break;
      }
    }

    for (let index = 0; index < args.xFields.length; index++) {
      const element = args.xFields[index];
      this.setCellAlign(rowHeaders[index], element);
      rowHeaders[index].render = (value, record, rowIndex) => {
        // console.log(' rowHeaders[index].render0 ',value,rowIndex);

        if (value === "-" || !value) {
          return <div className="data-null">{value}</div>;
        }

        //序号列
        if (element.tag === "f_row_order") {
          return <div className="row-order">{value}</div>;
        }

        //首列汇总
        if (index === 0) {
          if (rowIndex === that.gathercolSpanRowIndex) {
            return <div className="data-cell">{value}</div>;
          }
        }
        // if ((!that.props.triggers || that.props.triggers.length === 0)) {
        //   return <div className="data-cell">{value}</div>
        // }
        // console.log("小计", value);
        let cell =
          typeof value === "object" ? (
            value && value.is_subtotal ? (
              <span style={{ fontWeight: "bold" }}>
                {React.language("dash.showSubtotal.tip")}
              </span>
            ) : (
              value
            )
          ) : (
            value
          );
        return (
          <div
            className="cell-linkdata"
            onClick={() => {
              //图表联动触发
              let dd = this.getFilterColHeaderDataId(
                element,
                rowIndex,
                index,
                args
              );
              that.onItemClick(dd);
            }}
          >
            {cell}
          </div>
        );
      };

      rowHeaders[index].lock = isHeadSticky;
      rowHeaders[index].width = this.getWidgetWidth(
        element.type,
        rowHeaders[index].code
      );
      if (element.tag === "f_row_order") {
        rowHeaders[index].width = 50;
      }
      rowHeaders[index].getCellProps = (value, record, rowIndex) => {
        //首列汇总
        if (index === 0) {
          // console.log("827 that.gathercolSpanRowIndex", that.state.gathercolSpanRowIndex)
          if (rowIndex === that.state.gathercolSpanRowIndex) {
            // let dv = this.getColumnAlign({ alignment: this.state.summaryTitleAlignment }) ? (this.getColumnAlign({ alignment: this.state.summaryTitleAlignment }) + ' !important') : "";

            return {
              colSpan: args.xFields.length,
              className: " gather ",
              // style: { 'textAlign': dv }
            };
          }
        }
        let key = [rowIndex, index].join("_");
        if (this.rowspanObj[key]) {
          return {
            rowSpan: this.rowspanObj[key],
          };
        }
        return {};
      };
    }
    if (args.xFields.length === 0) {
      //维度行 等于 0的情况
      let element = args.yFields[0];

      let index = 0;
      if (rowHeaders.length > 0) {
        rowHeaders[index].render = (value, record, rowIndex) => {
          // console.log(' rowHeaders[index].render1 ',value,rowIndex);
          if (value === "-" || !value) {
            return <div className="data-null">{value}</div>;
          }

          //序号列
          if (element.tag === "f_row_order") {
            return <div className="row-order">{value}</div>;
          }

          //首列汇总
          if (index === 0) {
            if (rowIndex === that.state.gathercolSpanRowIndex) {
              return <div className="data-cell">{value}</div>;
            }
          }
          // if ((!that.props.triggers || that.props.triggers.length === 0)) {
          //   return <div className="data-cell">{value}</div>
          // }
          // console.log("小计", value);
          let cell =
            typeof value === "object" ? (
              value && value.is_subtotal ? (
                <span style={{ fontWeight: "bold" }}>
                  {React.language("dash.showSubtotal.tip")}
                </span>
              ) : (
                value
              )
            ) : (
              value
            );
          return (
            <div
              className="cell-linkdata"
              onClick={() => {
                //图表联动触发
                let dd = this.getFilterColHeaderDataId(
                  element,
                  rowIndex,
                  index,
                  args
                );
                that.onItemClick(dd);
              }}
            >
              {cell}
            </div>
          );
        };

        rowHeaders[index].lock = isHeadSticky;
        rowHeaders[index].width = this.getWidgetWidth(
          element.type,
          rowHeaders[index].code
        );
        if (element.tag === "f_row_order") {
          rowHeaders[index].width = 50;
        }
        rowHeaders[index].getCellProps = (value, record, rowIndex) => {
          //首列汇总
          if (index === 0) {
            if (rowIndex === that.state.gathercolSpanRowIndex) {
              return {
                colSpan: args.xFields.length,
                className: " gather ",
                // style: { 'textAlign': this.getColumnAlign({ alignment: this.state.summaryTitleAlignment }) }
              };
            }
          }
          let key = [rowIndex, index].join("_");
          if (this.rowspanObj[key]) {
            return {
              rowSpan: this.rowspanObj[key],
            };
          }
          return {};
        };
      }
    }

    let colHeaders = [];
    //处理行表头
    for (let index = dataStart; index < headers.length; index++) {
      if (args.yFields.length === 0) {
        colHeaders.push(headers[index]);
      } else {
        colHeaders = colHeaders.concat(drilling(headers[index]));
      }
    }
    for (let colIndex = 0; colIndex < colHeaders.length; colIndex++) {
      for (
        let metricsIndex = 0;
        metricsIndex < args.metrics.length;
        metricsIndex++
      ) {
        const element = args.metrics[metricsIndex];
        const colHeadersIndex = colIndex + metricsIndex;
        this.setCellAlign(colHeaders[colHeadersIndex], element);
        colHeaders[colHeadersIndex].width = this.getWidgetWidth(
          "number",
          colHeaders[colHeadersIndex].code
        );
        colHeaders[colHeadersIndex].number = true;
        colHeaders[colHeadersIndex].headerCellProps = {
          className: "number",
        };

        colHeaders[colHeadersIndex].render = (value, record, rowIndex) => {
          // console.log(' colHeaders[colHeadersIndex].render ',value,rowIndex);
          if (value === "-" || !value)
            return <div className="data-null">{value}</div>;

          // if ((!that.props.triggers || that.props.triggers.length === 0)) {
          //   return <div className="data-cell">{value}</div>
          // }
          // console.log("小计", value);
          let cell =
            typeof value === "object" ? (
              value && value.is_subtotal ? (
                <span style={{ fontWeight: "bold" }}>
                  {React.language("dash.showSubtotal.tip")}
                </span>
              ) : (
                value
              )
            ) : (
              value
            );

          return (
            <div
              className="cell-linkdata"
              onClick={() => {
                //图表联动触发
                let dd = this.getFilterDataId(
                  element,
                  rowIndex,
                  colHeadersIndex,
                  args
                );
                that.onItemClick(dd);
              }}
            >
              {cell}
            </div>
          );
        };
      }
      colIndex = colIndex + args.metrics.length - 1;
    }
    // console.log(headers)

    this.theaderdata = [];

    for (let i = 0; i < headerdata.length; i++) {
      let dd = headerdata[i];
      let obje = {};
      for (let j = 0; j < dd.length; j++) {
        if (j < rowHeaders.length) {
          var k = rowHeaders[j].code;
          obje[k] = headerdata[i][j];
        } else {
          var k = colHeaders[j - rowHeaders.length].code;
          obje[k] = headerdata[i][j];
        }
      }
      this.theaderdata.push(obje);
    }
    // console.log(this.theaderdata)

    // let endcol = Object.assign({}, headers[headers.length - 1]);

    // function de(e) {
    //   e.code = "blank";
    //   if (e.children && e.children.length) {
    //     e.children = [e.children[0]];
    //     de(e.children[0]);
    //   }
    // }
    // de(endcol);
    headers.push({
      code: "blank",
      lock: false,
      width: "auto",
    });
    return [...headers];
  };

  //处理行表头的合并标识
  getRowSpan = (dataSource, args, skip) => {
    const { limit } = this.state;
    skip = skip || 0;
    let that = this;
    this.rowspanObj = {};
    if (args.xFields.length) {
      let dd = [];
      for (let index = 0; index < args.xFields.length; index++) {
        let row = [];

        for (let dataIndex = 0; dataIndex < limit; dataIndex++) {
          let basdindex = skip * limit + dataIndex;
          if (dataSource[basdindex]) {
            let key =
              args.xFields[index].title +
              that.state.headercodeSplitstr +
              args.xFields[index].tag;
            if (args.yFields.length > 0) {
              key = this.datakeys[index];
            }
            const element = dataSource[basdindex][key];
            row.push(element);
          }
        }
        dd.push(row);
      }

      let transformRowColumns = (headerdata) => {
        let drmap = [];
        let lastValue = "";
        let dic = 1;
        let lastCol = 0;
        for (let i = 0; i < headerdata.length; i++) {
          drmap.push({});
          let rowdata = headerdata[i];

          if (i > 0) {
            if (drmap[i - 1][lastCol]) {
              drmap[i - 1][lastCol].count = dic;
            }
          }
          lastValue = "";
          dic = 1;
          lastCol = 0;
          for (let j = 0; j < rowdata.length; j++) {
            if (i == 0) {
              if (headerdata[i][j] != lastValue) {
                if (drmap[i][lastCol]) {
                  drmap[i][lastCol].count = dic;
                }

                dic = 1;
                lastCol = j;
                drmap[i][j] = {
                  name: <span className="col-title">{headerdata[i][j]}</span>,
                  count: 1,
                };
              } else {
                dic++;
              }
            } else {
              if (!drmap[i - 1][j]) {
                //上级是合并状态，本地也要判断
                if (headerdata[i][j] != lastValue) {
                  if (drmap[i][lastCol]) {
                    drmap[i][lastCol].count = dic;
                  }

                  dic = 1;
                  lastCol = j;
                  drmap[i][j] = {
                    name: <span className="col-title">{headerdata[i][j]}</span>,
                    count: 1,
                  };
                } else {
                  dic++;
                }
              } else {
                if (drmap[i][lastCol]) {
                  drmap[i][lastCol].count = dic;
                }

                dic = 1;
                lastCol = j;
                drmap[i][j] = {
                  name: <span className="col-title">{headerdata[i][j]}</span>,
                  count: 1,
                };
              }
            }

            lastValue = headerdata[i][j];
          }
        }

        if (drmap[headerdata.length - 1][lastCol]) {
          drmap[headerdata.length - 1][lastCol].count = dic;
        }

        return drmap;
      };

      let t1 = new Date().getTime();
      let map = transformRowColumns(dd, args);
      let t2 = new Date().getTime();
      // console.log(JSON.stringify(dd));
      // console.log(JSON.stringify(dd));
      // console.log('getRowSpan1:' + (t2 - t1));

      t1 = new Date().getTime();
      for (let jj = 0; jj < map.length; jj++) {
        BsyUtils.forEach(map[jj], (k, val) => {
          if (val.count > 1) {
            for (var i = 0; i < val.count; i++) {
              this.rowspanObj[[parseInt(k) + i, jj].join("_")] = val.count - i;
            }
          }
        });
      }
      t2 = new Date().getTime();
      // console.log('getRowSpan2:' + (t2 - t1));
      // console.log(this.rowspanObj)
    }
  };

  valueFormat = (value, header) => {
    // let r = BsyUtils.fixDecimalPrecision(value);
    // let text = BsyUtils.num2Str(r, header.format);

    // let res = BsyUtils.numberFormatValue(value, header);
    // value = res;
    let res = {
      value: "",
      text: "",
    };
    if (
      ["flow_assist.assist_protime", "flow_assist.assist_outtime"].includes(
        header.name
      )
    ) {
      res = BsyUtils.numberFormatTime(value, header);
    } else {
      res = BsyUtils.numberFormatValue(value, header);
      const afterSuffixVal = getAfterSuffix(header.afterSuffix)
      if (afterSuffixVal && res.text && !res.text.includes("%")) {
        res.text = res.text + " " +afterSuffixVal;
      }
    }
    return res.text;
  };

  //处理数据
  transformDataSource = (args, skip) => {
    let that = this;
    let t1 = new Date().getTime();
    let dataSource = [];

    if (args.xFields.length === 0) {
      let rowObj1 = {};
      for (let index = 0; index < this.datakeys.length; index++) {
        if (index === 0) {
          rowObj1[this.datakeys[index]] = React.language("gather");
        } else {
          rowObj1[this.datakeys[index]] = this.valueFormat(
            args.data.val[index - 1].sum,
            args.metrics[(index - 1) % args.metrics.length]
          );
        }
      }
      dataSource = [rowObj1];
    } else {
      //数据为空
      if (args.data.val.length === 0 && args.data.x.length === 0) {
        return [];
      }
      // 行表头部门
      for (let vali = 0; vali < args.data.x[0].data.length; vali++) {
        let rowObj = {};
        for (let index = 0; index < args.xFields.length; index++) {
          let k =
            args.xFields[index].title +
            that.state.headercodeSplitstr +
            args.xFields[index].tag;
          if (args.yFields.length > 0) {
            k = this.datakeys[index];
          }
          rowObj[k] = this.transformgroupRule(
            args.data.x[index].data[vali],
            args.xFields[index],
            args
          );
        }
        if (args.yFields.length > 0) {
          for (
            let index = args.xFields.length;
            index < this.datakeys.length - args.metrics.length;
            index++
          ) {
            let key = this.datakeys[index];
            rowObj[key] = args.data.val[index - args.xFields.length].data[vali];
            if (!rowObj[key] && rowObj[key] !== 0) {
              rowObj[key] = "-";
            } else {
              rowObj[key] = this.valueFormat(
                rowObj[key],
                args.metrics[
                  (index - args.xFields.length) % args.metrics.length
                ]
              );
            }
            // console.log('xFields0', index, key, rowObj[key])
            // metricsIndex++;
          }
          for (let index = 0; index < args.metrics.length; index++) {
            let key =
              this.datakeys[this.datakeys.length - args.metrics.length + index];
            rowObj[key] =
              args.data.val[
                args.data.val.length - args.metrics.length + index
              ].data[vali];
            if (!rowObj[key] && rowObj[key] !== 0) {
              rowObj[key] = "-";
            } else {
              rowObj[key] = this.valueFormat(rowObj[key], args.metrics[index]);
            }
            // console.log('xFields1', index, key, rowObj[key])
          }
        }
        for (let index = 0; index < args.metrics.length; index++) {
          let key =
            args.metrics[index].title +
            that.state.headercodeSplitstr +
            args.metrics[index].tag;
          rowObj[key] = args.data.val[index].data[vali];
          if (!rowObj[key] && rowObj[key] !== 0) {
            rowObj[key] = "-";
          } else {
            rowObj[key] = this.valueFormat(rowObj[key], args.metrics[index]);
          }
          // console.log('xFields2', index, key, rowObj[key])
        }
        dataSource.push(rowObj);
      }
      // 汇总部分
      let rowObj = {};
      for (let index = 0; index < args.xFields.length; index++) {
        let k =
          args.xFields[index].title +
          that.state.headercodeSplitstr +
          args.xFields[index].tag;
        if (args.yFields.length > 0) {
          k = this.datakeys[index];
        }
        rowObj[k] = React.language("gather");
      }
      if (args.yFields.length > 0) {
        for (
          let index = args.xFields.length;
          index < this.datakeys.length - args.metrics.length;
          index++
        ) {
          let key = this.datakeys[index];
          rowObj[key] = args.data.val[index - args.xFields.length].sum;

          if (!rowObj[key] && rowObj[key] !== 0) {
            rowObj[key] = "-";
          } else {
            rowObj[key] = this.valueFormat(
              rowObj[key],
              args.metrics[(index - args.xFields.length) % args.metrics.length]
            );
          }
          // console.log('yFields0', index, key, rowObj[key])
          // metricsIndex++;
        }

        for (let index = 0; index < args.metrics.length; index++) {
          let key =
            this.datakeys[this.datakeys.length - args.metrics.length + index];
          rowObj[key] =
            args.data.val[
              args.data.val.length - args.metrics.length + index
            ].sum;
          if (!rowObj[key] && rowObj[key] !== 0) {
            rowObj[key] = "-";
          } else {
            rowObj[key] = this.valueFormat(rowObj[key], args.metrics[index]);
          }
          // console.log('yFields1', index, key, rowObj[key])
        }
      } else {
        for (let index = 0; index < args.metrics.length; index++) {
          let key =
            args.metrics[index].title +
            that.state.headercodeSplitstr +
            args.metrics[index].tag;
          rowObj[key] = args.data.val[index].sum;
          rowObj[key] = this.valueFormat(rowObj[key], args.metrics[index]);

          // console.log('all', index, k, rowObj[k])
        }
      }
      dataSource.push(rowObj);
    }
    let t2 = new Date().getTime();

    that.gathercolSpanRowIndex = dataSource.length - 1;
    // console.log('transformDataSource1:' + that.gathercolSpanRowIndex)
    that.getRowSpan(dataSource, args, skip);
    return [...dataSource];
  };

  _getColSizeMapKey = () => {
    const { appId, entryId, widgetId } = this.props;
    return BsyUtils.Store.getKey("BsyPivotTable", {
      appId: appId,
      entryId: entryId,
      widgetId: widgetId,
    });
  };

  _getColSizeMap = () => {
    let t = this._getColSizeMapKey();
    return BsyUtils.Store.get(t) || {};
  };

  _updateColSize = (val) => {
    let columnResize = {};
    for (let i = 0; i < this.datakeys.length; i++) {
      var columns = this.datakeys[i];
      //___￡___

      columnResize[columns] = val[i];
    }
    let i = this._getColSizeMapKey();
    BsyUtils.Store.set(i, columnResize);
  };

  _isFieldsValid = () => {
    let t = this.state,
      e = !0;
    e &= !BsyUtils.isEmpty(t.forms[0]);
    e &= 0 !== t.valueFields.length;
    e &= 0 !== t.xFields.length || 0 !== t.yFields.length;
    return e;
  };

  onscroll = (event) => {
    let scrollLeft =
      this.element.current.querySelector(".art-sticky-scroll").scrollLeft;
    if (scrollLeft > 0) {
      // console.log('开始移动');
      this.element.current.classList.add("scroll-background");
    } else {
      // console.log('最左边');
      this.element.current.classList.remove("scroll-background");
    }
  };

  //处理数据
  pipeline = () => {
    if (this.element.current) {
      let atb = this.element.current.querySelector(".art-sticky-scroll");
      if (atb) {
        atb.removeEventListener("scroll", this.onscroll);
        atb.addEventListener("scroll", this.onscroll, false);
      }
    }

    const { dataSource, columns } = this.state;
    const pipeline = new TablePipeline({
      ctx: { components: { Checkbox: BsyCheckBox } },
      state: this.state.pipelineState,
      setState: this.setPipelineState,
    });

    pipeline.input({ dataSource, columns });
    pipeline.primaryKey("originalrow"); // 每一行数据由 id 字段唯一标记

    //列之间拖动
    pipeline.use(
      features.columnResize({
        defaultSizes: this.lastcolumnResize,
        /** 受控用法：列宽数组 */
        sizes: this.lastcolumnResize,
        onChangeSizes: () => {
          // console.log('onChangeSizes', size)
          let resize = this.element.current.querySelector(
            ".column-resizer-line"
          );
          if (resize) {
            resize.style.display = "none";
          }

          setTimeout(() => {
            //做1个像素偏移，防止头部错位，取巧的解决方式，具体原因找不到
            let scroll =
              this.element.current.querySelector(".art-sticky-scroll");
            let scrollLeft = scroll.scrollLeft;
            // console.log('scrollLeft', scrollLeft);
            scroll.scrollLeft = scrollLeft + (scrollLeft > 0 ? -1 : 1);
            scroll.scrollLeft = scrollLeft;
          }, 10);
        },
        onChnageSizePos: (sizes, pos) => {
          // console.log('onChnageSizePos', sizes)
          // console.log(sizes.slice(0, pos + 1))
          this.lastcolumnResize = [...sizes];
          this._updateColSize([...sizes]);

          let sumValue = sizes.slice(0, pos + 1).reduce(function (sum, number) {
            //sum2 前两个数的和

            return sum + number;
          }, 0);

          let scrollLeft =
            this.element.current.querySelector(".art-sticky-scroll").scrollLeft;
          let resizer = this.element.current.querySelector(
            ".column-resizer-line"
          );
          if (resizer) {
            resizer.style.display = "block";
            resizer.style.left = sumValue - scrollLeft - 3 + "px";
          }
        },
        fallbackSize: 100,
        minSize: 50,
        handleBackground: "#ddd",
        handleHoverBackground: "#aaa",
        handleActiveBackground: "#89bff7",
      })
    );

    return pipeline.getProps();
  };

  UNSAFE_componentWillReceiveProps(nextProps, nextContext) {
    if (nextProps.isDashFull !== this.isDashFull) {
      this.isDashFull = nextProps.isDashFull;
      this.setState({});
    }
  }

  showLoading = () => {
    const { isLoading } = this.state;
    if (!this.isDashFull) {
      //非自动刷新模式下
      return isLoading ? <BsySLoading mode={"skeletonspin"} /> : "";
    }
    if (
      !(
        this.props.autoRefresh &&
        this.props.autoRefresh &&
        this.props.autoRefresh.enabled
      )
    ) {
      //非自动刷新模式下
      return isLoading ? <BsySLoading mode={"skeletonspin"} /> : "";
    }
    return "";
  };

  getWidgetWidth = (type, name1) => {
    let colMap = this._getColSizeMap() || {};
    let name = name1;
    if (name1 && name1.indexOf(".") == -1) {
      name = "." + name1;
    }
    switch (type) {
      case "number": {
        return colMap[name] || 100;
      }
      case "address":
      case "deptgroup":
      case "usergroup":
      case "combocheck":
      case "checkboxgroup": {
        return colMap[name] || 250;
      }
      case "dept":
      case "user":
      case "text":
      case "datetime":
      case "radiogroup":
      case "combo":
      case "sn":
      default: {
        return colMap[name] || 150;
      }
    }
  };

  skipChange = (e) => {
    // console.log('skipChange', e)

    if (
      this.element.current &&
      this.element.current.querySelector(".art-sticky-scroll")
    )
      this.scrollLeft =
        this.element.current.querySelector(".art-sticky-scroll").scrollLeft;
    if (this.props.onReload) {
      this.props.onReload(e, this.resultData);
    }
  };

  dataReload = (skip, resultData) => {
    this.resultData = resultData;
    this.g_header = this.transformColumns(resultData);

    let red = this.getLastHeaderChildren(
      this.g_header[this.g_header.length - 1].children,
      1
    );
    // console.log(red)
    if (red.children) {
      this.g_header[this.g_header.length - 1].children = red.children;
    }

    this.g_data = this.transformDataSource(resultData, skip);
    this.goPage(skip, () => {
      setTimeout(() => {
        if (
          this.element.current &&
          this.element.current.querySelector(".art-sticky-scroll")
        )
          this.element.current.querySelector(".art-sticky-scroll").scrollLeft =
            this.scrollLeft;
        setTimeout(() => {
          this.setState({
            isLoading: false,
          });
        }, 150);
      }, 10);
    });
  };

  listLimitChange = (e) => {
    // console.log('listLimitChange', e)
    this.setState(
      {
        skip: 0,
        limit: e,
      },
      () => {
        this.loadData();
      }
    );
  };

  render() {
    const {
      dataSource,
      skip,
      limit,
      columns,
      isLoading,
      widgetId,
      dataEmpty,
      isRowHeadSticky,
    } = this.state;

    return (
      <div
        className={
          "pivot-table data-table " +
          this.platform +
          " " +
          (dataEmpty ? "data-empty" : "")
        }
        id={widgetId}
        ref={this.element}
      >
        {dataEmpty ? (
          <div className={"chart-data-empty"}>
            <div>
              <i
                className={BsyUtils._getWidgetTypeIcon(this.state.chartType)}
              ></i>
              <span>{React.language("widget.linkdata.empty")}</span>
            </div>
          </div>
        ) : (
          <>
            <div
              className={`chart-data-border`}
              style={{
                overflowX: "hidden",
                overflowY: "auto",
                height: "calc( 100% - 40px )",
              }}
            >
              <BaseTable
                stickyMode={"css"}
                useVirtual={{ vertical: 30 }} //虚拟行开关
                // dataSource={dataSource}
                useOuterBorder={false}
                // columns={columns}
                isStickyHeader={isRowHeadSticky}
                // isSyncColGroup={true}
                components={{
                  EmptyContent: () => {
                    return (
                      <tr
                        className="art-table-row first last no-hover"
                        data-rowindex="0"
                      >
                        <td
                          className="art-table-cell first last"
                          colSpan="6"
                          style={{ height: 200 }}
                        >
                          <div className="art-empty-wrapper">
                            <tr></tr>{" "}
                          </div>
                        </td>
                      </tr>
                    );
                  },
                  Row: ({ row, rowIndex, trProps }) => {
                    let className = trProps.className;

                    // className = className.replace("odd", "");
                    // className = className.replace("even", "")

                    return <tr {...trProps} className={className} />;
                  },
                  Cell: ({ row, column, tdProps }) => {
                    //处理条件颜色
                    let clsstyle = {
                      ...tdProps.style,
                    };
                    if (column.lock) {
                      clsstyle.cursor = "pointer";
                    }
                    let cssName = tdProps.className;
                    if (column.number) {
                      cssName += " number";
                    }

                    return (
                      <td
                        {...tdProps}
                        ref={(node) => {
                          if (node) {
                            if (node.style) {
                              if (cssName.indexOf("gather") > -1) {
                                let align = this.getColumnAlign({
                                  alignment: this.state.summaryTitleAlignment,
                                });
                                if (align)
                                  node.style.setProperty(
                                    "text-align",
                                    align,
                                    "important"
                                  );
                              }
                            }
                          }
                        }}
                        style={clsstyle}
                        className={cssName}
                      />
                    );
                  },
                }}
                {...this.pipeline()}
              />
            </div>

            <div className="page">
              <BsyTurnPage
                skipChange={this.skipChange}
                listLimitChange={this.listLimitChange}
                limit={limit}
                hasTurnLast={true}
                skip={skip}
                count={this.g_data.length}
                hasCount={false}
                theme={this.props.theme}
                // styleType={styleType}
              />
            </div>
          </>
        )}

        {this.showLoading()}
      </div>
    );
  }

  BBY_doExcelExport = (e) => {
    let i = this.state;
    let n = this._isFieldsValid();
    if (i.isLoading) {
      return;
    }
    if (n) {
      window.FX.Msg.notice({
        title: React.language("export.excel.notice.title"),
        type: "async",
        duration: 0,
        content: React.language("export.excel.notice.content"),
      });

      React.axios("/data/report_datatable_export", {
        appId: i.appId,
        entryId: i.entryId,
        widgetId: i.widgetId,
        title: i.title,
        popupFormPath: this.popupFormPath.concat({
          appId: this.props.appId,
          entryId: this.props.entryId,
          formId: this.props.forms[0],
          widgetId: this.props.widgetId,
        }),
        filter: this.getFilterData(this.filterParam),
        sort: this.state.sort,
        name: [i.dashTitle, i.title].join(
          window.FX.CONST.DASH_CHART_TITLE_DELIMITER
        ),
      })
        .then((res) => {
          let b = res.data;
          let e = window.$("<div />").append(
            window.$("<p />").text(
              React.language("export.excel.fileSuccess.content", {
                name: [i.dashTitle, i.title].join(
                  window.FX.CONST.DASH_CHART_TITLE_DELIMITER
                ),
                time: BsyUtils.convertToRemainingTime(24 * 60 * 60, "hour"),
              })
            )
          );
          e.append(
            window
              .$("<a href='javascript:void(0);' />")
              .text(React.language("download.immediately"))
              .on("click", function () {
                BsyUtils.downloadFile2(
                  [i.dashTitle, i.title].join(
                    window.FX.CONST.DASH_CHART_TITLE_DELIMITER
                  ),
                  b.url
                );
                return false;
              })
          );
          window.FX.Msg.notice({
            title: React.language("export.excel.fileSuccess"),
            type: "success",
            duration: 0,
            content: window.$(e),
          });
        })
        .catch((res) => {
          console.error(res);
        });

      return;
    }
  };

  BBY_doSort = () => {
    var t = this.props,
      e = this,
      i = BsyUtils.getDashSortFields(t.yFields)
        .concat(BsyUtils.getDashSortFields(t.xFields))
        .concat(BsyUtils.getDashQuotaSortFields(t.metrics)),
      a = [];
    BsyUtils.forEach(
      t.xFields.slice(-1).concat(t.valueFields),
      function (t, e) {
        a.push(e.tag);
      }
    );
    var n = new window.FX.ConfirmDialog({
      title: React.language("dash.sort.setting"),
      width: 600,
      text4Ok: React.language("sort"),
      hasSeparator: !0,
      onContentCreate: function (t) {
        e.dashChartSort = new window.FX.DashChartSortPane({
          renderEl: t,
          sorts: e.state.sort,
          fields: i,
          incompatibleTags: a,
          maxCount: -1,
          hideCustomSort: !0,
        });
      },
      onOk: function () {
        var t = e.dashChartSort.getSorts();
        e.setState(
          {
            sort: t,
          },
          () => {
            e.loadData();
          }
        );
        n.close();
      },
    });
    n.show();
  };
}
